<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
          智能AI
        </div>
        <div class="txt">
          Intelligent AI
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/pic21.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">地电波监测机械臂</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            地电波检测机械臂装置是一种工作在无人变电站环境下，依附于巡检机器人实现变电站设备地电波数据检测及故障诊断的智能装置，对机械臂机械结构的灵活性、稳定性有极高要求。实际使用下要求地电波检测机械臂装置在存储状态时占据较小空间且无安全隐患，机械臂执行探测任务时动作要稳固可靠且能够测量1.2米以外设备的地电波/超声波数据，关于此类设备国内目前尚无可行的设计方案。<br>
本产品针对地电波检测机械臂装置提出了一套可行的机械臂机械结构设计方案，能够与巡检机器人有机的结合在一起，依托于巡检机器人的运动和定位能力实现对变电站设备的巡检，然后通过探测机械臂伸送地电波传感器，实现对变电站设备地电波数据的采集和故障诊断功能，所提出的方案极大扩展了无人值守巡检机器人的巡检作业能力，具备一定的市场推广价值，对促进变电站安全稳定运行，提高供电可靠性具有重要意义，其应用前景广阔。
          </div>
          <div class="title">相关案例</div>
          <img src='../assets/pic41.png' alt="" @click="gotoDetail">
          <div class="txt last">地电波监测机械臂</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list">
            <div class="title">机械臂机械结构</div>
            <div class="en">Robotic arm mechanical structure</div>
            <div class="txt"><span class="el-icon-caret-right"></span>所设计的地电波探测机械臂与巡检机器人有机的结
合在一起，在巡检机器人运动到合适位置后进行动
作，可完成对探测传感器的收放动作，机械臂最大
伸展半径为1.5米，在机械臂无需动作的工况下，机
械臂能够将自身及所携带地电波传感器等器件回收
至存储位，保证自身占据较小的空间，不会干涉巡
检机器人运动并且不会对周围人员或设备构成潜在
威胁，整体机械结构采用模块化设计，具有较高的
机构灵活性，机械部件动作可靠稳定，流畅且安静，
结构子模块易更换易维修。</div>
            
          </div> 
          <div class="more_list">
            <div class="title">多输入冗余纠错位置反馈策略</div>
            <div class="en">Multi-input redundant error 
correction position feedback strategy</div>
            <div class="txt"><span class="el-icon-caret-right"></span>本项目针对距离传感器设计了专门的卡尔曼滤波器，
以超声波距离传感器测量数据和机械臂运动速度为
输入得出机械臂与设备间距的最优估计值，有效的
抑制了距离传感器测量数据的高斯噪声，再搭配两
个行程开关作为端点校正，能够更加精准的控制机
械臂收放过程。</div>
          </div>
          <div class="more_list end">
            <div class="title">地电波数据故障诊断策略</div>
            <div class="en">Geowave data troubleshooting strategy</div>
            <div class="txt"><span class="el-icon-caret-right"></span>不同地电波设备在不同环境下具有不同地电波特征表
现，本项目基于神经网络分类框架实现对地电波测量
数据的智能诊断，通过大量训练可实现极高的故障分
析成功率。</div>
          </div>
          
        </div>
        <div class="more_bottom">
          <div class="more_list">
            <div class="title">特色功能</div>
            <div class="en">Featured Features</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1）手动/自动控制模式灵活切换，工作人员可打断
机械臂装置自动探测模式，远程手动控制，退出手
动模式后，机器人自动复位，继续巡检任务；
2）携带众多必要传感器：氧气含量传感器、环境
温度传感器、湿度传感器、烟雾传感器、有害气体
含量传感器等，实时监测变电站环境状况；
3）配备本地独立数据库进行数据的存储及读取，控
制终端预留对电站内网接口，实现巡检数据的共享；
4）控制终端实时监视电池电量，实现巡检机器人低
电量下自主提示并报警。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail7')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 280px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;
}
.more_detail .end {
  margin-right: 0;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor6.vue